import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';


const OPEN = 'cam4/drawer/OPEN';
const CLOSE = 'cam4/drawer/CLOSE';
const TOGGLE = 'cam4/drawer/TOGGLE';

export const NAME = 'drawer';

const initialState = Immutable.Map();

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case OPEN:
      return state.set(action.drawer, true);

    case CLOSE:
      return state.set(action.drawer, false);

    case TOGGLE: {
      const current = state.get(action.drawer);

      return state.set(action.drawer, !current);
    }

    default:
      return state;
  }
}

const drawer = (state) => state[NAME];

function open(drawer) {
  return {
    type: OPEN,
    drawer,
  };
}

function close(drawer) {
  return {
    type: CLOSE,
    drawer,
  };
}

function toggle(drawer) {
  return {
    type: TOGGLE,
    drawer,
  };
}

export const selector = createStructuredSelector({ drawer });

export const actionCreators = {
  open,
  close,
  toggle,
};
